export default [
    {
      path: '/plans/network/list',
      name: 'plans.network.list',
      component: () => import('@/views/modules/plans/network-plan/plan-list/PlansList'),
      meta: {
        module: 'plans.network',
        pageTitle: 'List All network Plans',
        breadcrumb: [
        // { text: 'List network Plans', active: true, },
          //{ text: 'Create Plan', to: {name: 'plans.rain.create'} }
        ],
      }
    },
  
  
    {
      path: '/plans/network/create',
      name: 'plans.network.create',
      component: () => import('@/views/modules/plans/network-plan/create/CreateNetworkPlan'),
      meta: {
        module: 'plans.network',
        pageTitle: 'Plan Create',
        breadcrumb: [
          { text: 'List Plans', to: {name: 'plans.network.list'} },
          { text: 'Create network' , active: true}
        ],
      }
    },
  
  
    {
      path: '/plans/network/:id/edit',
      name: 'plans.network.edit',
      component: () => import('@/views/modules/plans/network-plan/edit/EditNetworkPlan'),
      meta: {
        module: 'plans.network',
        pageTitle: 'Drainge Plan Edit',
        breadcrumb: [
          { text: 'List Plans', to: {name: 'plans.network.list'} },
          { text: 'Edit Plan' , to: {name: 'plans.network.edit'}},
         
        ],
      }
    },
  ]
  